module.exports = __webpack_public_path__ + "img/dekstop.f4a73c99.png";